import { createStore, combineReducers } from "redux";
import { lostReducer } from "./reducers/LostReducer.js";
import { foundReducer } from "./reducers/FoundReducer.js";
import { lostHistoryReducer } from "./reducers/LostHistoryReducer.js";
import { foundHistoryReducer } from "./reducers/FoundHistoryReducer.js";
import { claimReducer } from "./reducers/ClaimReducer.js";
import { userReducer } from "./reducers/UserReducer.js";
import { authReducer } from "./reducers/AuthReducer.js";
import { flashReducer } from "./reducers/FlashReducer.js";

export const configureStore = () => {
  const store = createStore(
    combineReducers({
      lostItems: lostReducer,
      foundItems: foundReducer,
      lostHistory: lostHistoryReducer,
      foundHistory: foundHistoryReducer,
      claimRequests: claimReducer,
      users: userReducer,
      auth: authReducer,
      flash: flashReducer,
    })
  );
  return store;
};
